import { removeMark, toggleMark } from '@atlaskit/editor-common/mark';
import { ACTIONS, pluginKey } from '../pm-plugins/main';
import { overrideMarks } from '../pm-plugins/utils/constants';
import { getDisabledStateNew } from '../pm-plugins/utils/disabled';
export var toggleColor = function toggleColor(color) {
  return function (_ref) {
    var tr = _ref.tr;
    var textColor = tr.doc.type.schema.marks.textColor;
    var disabledState = getDisabledStateNew(tr);
    if (disabledState) {
      tr.setMeta(pluginKey, {
        action: ACTIONS.DISABLE
      });
      return tr;
    }
    overrideMarks.forEach(function (mark) {
      var marks = tr.doc.type.schema.marks;
      if (marks[mark]) {
        removeMark(marks[mark])({
          tr: tr
        });
      }
    });
    toggleMark(textColor, {
      color: color
    })({
      tr: tr
    });
    return tr;
  };
};